import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { StatusBadge } from "@/components/StatusBadge";
import { rupiah, tanggal } from "@/lib/format";

export default function Receivables() {
  const { data, loading } = useFetch("/receivables");
  return (
    <div>
      <PageHeader title="Piutang" subtitle="Daftar invoice dengan sisa piutang & umur piutang (aging)" />
      {loading ? <div className="h-64 rounded-md bg-muted animate-pulse" /> : (
        <DataTable testId="receivables" data={data || []} columns={[
          { key: "number", label: "No. Invoice" },
          { key: "client", label: "Klien" },
          { key: "grand_total", label: "Total", numeric: true, render: (r) => rupiah(r.grand_total) },
          { key: "paid", label: "Dibayar", numeric: true, render: (r) => rupiah(r.paid) },
          { key: "outstanding", label: "Sisa Piutang", numeric: true, render: (r) => <span className="font-semibold text-rose-600">{rupiah(r.outstanding)}</span> },
          { key: "due_date", label: "Jatuh Tempo", render: (r) => tanggal(r.due_date) },
          { key: "age_days", label: "Umur", numeric: true, render: (r) => `${r.age_days} hari` },
          { key: "aging_bucket", label: "Aging", render: (r) => {
            const tone = r.aging_bucket === "Belum Jatuh Tempo" ? "bg-blue-50 text-blue-700 border-blue-200" : r.age_days > 60 ? "bg-rose-50 text-rose-700 border-rose-200" : "bg-amber-50 text-amber-700 border-amber-200";
            return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${tone}`}>{r.aging_bucket}</span>;
          } },
        ]} />
      )}
    </div>
  );
}
